module.exports = __webpack_public_path__ + "static/media/discount-tag.55274403.svg";